import { Alert } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import ChangesMakePayment from "../Changes-Make-Payments/ChangesMakePayment";
import AddressCard from "./components/Address-Card/AddressCard";

function ChangeInAddress(props) {
  const { AddressConfirmation, errMessage } = props;

  const {
    request_address,
    delete_address_array,
    edit_address_array,
    new_address_array,
    request,
  } = props.requestData;
  const { request_timeline_status, id, final_amount, discount } = request;

  const [isPayment, setIsPayment] = useState(false);

  const getChangeInPrice = () => {
    let add_price = 0;
    let edit_price = 0;
    let delete_price = 0;

    new_address_array.map((addr) => {
      add_price += addr.price;
    });

    edit_address_array.map((addr) => {
      edit_price += addr.price;
    });

    delete_address_array.map((addr) => {
      delete_price += addr.price;
    });

    return add_price + edit_price + delete_price;
  };

  const handleAccept = () => {
    console.log(getChangeInPrice(), "GET_CHANGE_IN_PRICE");
    if (getChangeInPrice() === 0 || request_timeline_status < 3) {
      AddressConfirmation("1");
    } else {
      setIsPayment(true);
    }
  };

  if (isPayment) {
    return (
      <ChangesMakePayment
        id={id}
        amount={getChangeInPrice()}
        old_amount={final_amount}
        new_amount={final_amount + getChangeInPrice()}
        ChangeInRequestConfirmation={AddressConfirmation}
        discount={discount}
      />
    );
  }

  return (
    <>
      <div className="row">
        <div className="col-12 col-lg-12" id="onebox">
          <div className=" rounded-box items-info-wrapper mt-2">
            <div className="info-header text-center">
              <h6 className="black-color">Orignal Address</h6>
            </div>
            <div className="info-detail-wrapper p-3 pt-20">
              <div className="row">
                {request_address.map((address, i) => (
                  <AddressCard
                    icon={true}
                    action=""
                    key={i}
                    index={i}
                    address={address}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-12 mt-4" id="twobox">
          <div className="rounded-box items-info-wrapper mt-2">
            <div className="info-header text-center">
              <h6 className="black-color">
                Changed Address (${getChangeInPrice()})
              </h6>
            </div>
            {errMessage && (
              <Alert variant="filled" severity="error">
                {errMessage}
              </Alert>
            )}
            <div className="info-detail-wrapper p-3 pt-20">
              <div className="row">
                {new_address_array.map((address, i) => (
                  <AddressCard
                    action={"Added" + " ($" + address.price + ")"}
                    icon={false}
                    key={i}
                    index={i}
                    address={address}
                  />
                ))}{" "}
                {edit_address_array.map((address, i) => (
                  <AddressCard
                    action={"Edited" + " ($" + address.price + ")"}
                    icon={false}
                    key={i}
                    index={i}
                    address={address}
                  />
                ))}
                {delete_address_array.map((address, i) => (
                  <AddressCard
                    action={"Deleted" + " ($" + address.price + ")"}
                    icon={false}
                    key={i}
                    index={i}
                    address={address}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="col-3"></div>
        <div className="col-6 mt-4  justify-content-center d-flex">
          <button
            className="custom-btn-small custom-buton m-4"
            onClick={handleAccept}
          >
            Accept
          </button>
          <button
            className="custom-btn-small custom-buton m-4"
            onClick={() => AddressConfirmation("0")}
          >
            Reject
          </button>
        </div>
        <div className="col-3"></div>
      </div>
    </>
  );
}

export default ChangeInAddress;
